import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"listingRoom",
	api.listingRooms
)({
	actions: {
		async listingRoomDelete(context, { id }) {
			await api.rooms("delete", {
				id
			});
			context.commit(`listingRoomDeleteSuccess`, id);
		}
	}
});
